"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const uiNodes_1 = require("../../uiNodes");
const types_1 = require("./types");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uiNodes_1.tapeNodes.file_generatedBorrowingBaseReport.isIntermediateRecord(tape), `intermediateToUINodes: tape is not an ${types_1.artifactType}`);
    const { id, artifactSlug } = tape;
    const { tapeDescription, operationDescription: _unused, createServicerReport, extendedResponseTapeUploads, fundingSubmissionArtifactSlug, } = tape.configuration;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            description: tapeDescription,
            createServicerReport: !!createServicerReport,
        },
    };
    if (extendedResponseTapeUploads) {
        tapeNode.configuration.extendedResponseTapeUploads = extendedResponseTapeUploads;
    }
    if (fundingSubmissionArtifactSlug) {
        tapeNode.configuration.fundingSubmissionArtifactSlug = fundingSubmissionArtifactSlug;
    }
    return {
        operationNode: null,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node } = params;
    (0, common_1.finleyAssert)(uiNodes_1.tapeNodes.file_generatedBorrowingBaseReport.isNode(node), `uiNodesToIntermediate: node is not a generatedBorrowingBaseReport node: ${node.metadata.tapeBuilderNodeType}`);
    const { artifactSlug, description: tapeDescription, createServicerReport, extendedResponseTapeUploads, fundingSubmissionArtifactSlug, } = node.configuration;
    const record = {
        id: node.metadata.tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug: null,
        loanProductSlug: null,
        externalFilename: null,
        configuration: {
            tapeDescription,
            createServicerReport,
            extendedResponseTapeUploads,
        },
    };
    if (fundingSubmissionArtifactSlug) {
        record.configuration.fundingSubmissionArtifactSlug = fundingSubmissionArtifactSlug;
    }
    return {
        record,
        operationNode: null,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map